import React, { useEffect } from 'react'
import Header from '../components/Header';
import SaleMarquee from '../components/SaleMarquee';
import HeroSection from '../components/Herosection';
import FeaturesBar from '../components/Featuresbar';
import ProductSlider from '../components/Productslider';
import BrandsSection from '../components/BrandsSection';
import FeatureProducts from '../components/FeatureProducts';
import CTABanner from '../components/CTABanner';
import Gallery from '../components/Gallery';
import Footer from '../components/Footer';

const Home = () => {

  useEffect(() => {
    document.title = "Home | dawaacare";
  }, [])

  return (
    <div>
      <Header />
      <HeroSection />
      <SaleMarquee />
      <FeaturesBar />
      <ProductSlider />
      <BrandsSection />
      <FeatureProducts />
      <CTABanner />
      <Gallery />
      <Footer />

    </div>
  )
}

export default Home
